import { Notification } from 'element-ui'
import { webSocketUrl } from "@/api/api";
import header from '../../src/components/Header'

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

let ReconnectingWebSocket = require('../utils/reconnecting-websocket')

export default new Vuex.Store({
  state: {
    ws: null
  },
  getters: {
    ws(){
      return state.ws;
    }
  },
  mutations: {
    INIT(state,ws){
      state.ws = ws
    }
  },
  actions: {
    getWebsocket({commit},userId){
      let ws = new ReconnectingWebSocket(webSocketUrl);
      ws.debug = true;
      ws.reconnectInterval = 500;
      ws.maxReconnectInterval = 1000;
      ws.onopen = function () {
        let sendObj = {
          type: 1,
          userId: userId
        }
        ws.send(JSON.stringify(sendObj))
      };
      ws.onmessage = function (obj) {
        let jsonObj = JSON.parse(obj.data);
        if(jsonObj.type === 1){
          commit('INIT',ws);
          console.log(jsonObj.msg)
        }else{
          header.getMessage(obj)
        }
      }
    }
  }
})




// WEBPACK FOOTER //
// ./src/utils/webSocket.js